// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import 'myWorld/layers/clippedTileLayer';

myw.TileLayer = myw.ClippedTileLayer.extend({
    /**
     * @class Define a myWorld specific tile layer for tiles supplied by the myWorld tile server.<br/>
     * Prevents browser from caching tiles between sessions
     * @extends {ClippedTileLayer}
     * @constructs
     * @param  {string} url     The base url for obtaining tiles
     * @param  {object} options Options as specified for {@link http://leafletjs.com/reference.html#tilelayer|L.TileLayer}
     */
    initialize(url, options) {
        //add the url template part that matches the myWorld tile server rest api
        //also add a random number to prevent the browser from caching tiles between sessions
        url = `${url}{z}/{x}/{y}.png?{cacheBust}`;

        options.cacheBust = Math.round(Math.random() * 1000000);

        myw.ClippedTileLayer.prototype.initialize.call(this, url, options);
    },

    redraw() {
        //set new cache bust token to ensure tiles are reloaded by the browser
        this.options.cacheBust = Math.round(Math.random() * 1000000);

        myw.ClippedTileLayer.prototype.redraw.call(this);
    }
});

export default myw.TileLayer;
